import React, { useState } from 'react'
import { BottomPagination, VirtualizedTable } from 'containers';
import { localizedStrings } from 'constants/localizedStrings';
import { useSelector } from 'react-redux';

export default function Pending({
    setPage,
    page
}) {

    const {
        pending,
        total,
        loadLoading,
    } = useSelector(state => state.solicitations);

    const [tableColumns,] = useState([
        { key: "descr", label: localizedStrings.solicitationDescription, type: "text" },
        { key: "period", label: localizedStrings.usagePeriod, type: "text" },
    ]);

    return (
        <>
            <VirtualizedTable
                columns={tableColumns}
                data={pending}
                context={"pending"}
                loading={loadLoading}
            />
            {!loadLoading && pending?.length !== 0 && (
                <BottomPagination
                    list={pending}
                    page={page}
                    setPage={setPage}
                    perPage={50}
                    total={total}
                />
            )}
        </>
    )
}
